import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

/** 상단 Overview + Radar */
export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;

  h2 {
    margin: 0px;
    ${getTypography("korean", "body1")}
    color: ${designTokens.colors.font.primary};
  }
`;

export const LeftSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
`;

/** 설명 텍스트 */
export const OverviewText = styled.p`
  margin: 0px;
  ${getTypography("korean", "body2")}
  color: ${designTokens.colors.font.tertiary};
`;

/** 비율 */
export const Ratio = styled.div`
  ${getTypography("korean", "body1")}
  color: ${designTokens.colors.font.primary};

  small {
    display: block;
    ${getTypography("korean", "body3")}
    color: ${designTokens.colors.font.tertiary};
  }
`;

export const RatioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  padding: 4px 12px;
  border-radius: 16px;
  border: 1px solid ${designTokens.colors.line.button};
  background-color: transparent;
  color: ${({ $isActive }) =>
    $isActive
      ? designTokens.colors.font.primary
      : designTokens.colors.font.tertiary};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  ${getTypography("korean", "body3")}

  span {
    ${getTypography("korean", "body3")}
    color: ${({ $isActive }) =>
      $isActive
        ? designTokens.colors.button.secondary
        : designTokens.colors.font.primary};
  }
`;

/** 통계 테이블 */
export const StatsTable = styled.div`
  display: flex;
  border: 1px solid ${designTokens.colors.line.button};
  border-radius: 8px;
  overflow: hidden;
`;

export const StatCell = styled.div<{ $isFirst: boolean; $isActive: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  border-left: ${({ $isFirst }) =>
    $isFirst ? "none" : `1px solid ${designTokens.colors.line.button}`};

  background-color: ${({ $isActive }) =>
    $isActive ? designTokens.colors.button.secondary : "transparent"};

  color: ${({ $isActive }) =>
    $isActive ? "#ffffff" : designTokens.colors.font.primary};

  .label {
    ${getTypography("korean", "body4")}
    margin-right: 8px;
  }

  .count {
    ${getTypography("korean", "body2")}
  }

  &:hover {
    background-color: ${designTokens.colors.line.point};
  }
`;
